import type { NavigationItemType } from "../../../root/layout/SidebarMenuItem";
import type { Paths } from "../../../shared/usePrivacyNavigate";
import { ScimMapping, prefetchScimMappingPage } from "./ScimMapping";

export const route: NavigationItemType["route"] = {
  path: "settings/scim-mapping/:tenantId?",
  element: <ScimMapping />,
};

export const to = (paths: Paths) => paths.scimMapping();

export const prefetch = prefetchScimMappingPage;
